// extracted by mini-css-extract-plugin
export default {"media":"Checkout_media__bCGT5"};